import { useProfile } from 'context/Profile'
import { useApplicationOrganization } from 'context/Organization'

export function useUserRole() {
  const { profile, isAuthenticated } = useProfile()
  const { organization } = useApplicationOrganization()

  if (!isAuthenticated) return {}

  const { role, organizations } = profile
  const userRole = role ?? organizations.find(({ organization: { id } }) => id === organization.id).role

  return { role: userRole }
}
